import { 
    SYSTEM_ADMIN_FETCH_NOTIFICATIONS,
    SYSTEM_ADMIN_FETCH_NOTIFICATIONS_SUCCESS,
    SYSTEM_ADMIN_FETCH_NOTIFICATIONS_FAILED,
  } from "../actions/types";
  
  export const INITIAL_STATE = {
    system_notifications:null,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case SYSTEM_ADMIN_FETCH_NOTIFICATIONS:
        return {
          ...state,
          loading:true
        };
      case SYSTEM_ADMIN_FETCH_NOTIFICATIONS_SUCCESS:
        return {
          ...state,
          system_notifications:action.payload,
          loading:false
        };
      case SYSTEM_ADMIN_FETCH_NOTIFICATIONS_FAILED:
        return {
          ...state,
          system_notifications:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      default:
        return state;
    }
  };
